import { useEffect, useState } from "react";
import axios from "axios";
import ListOfNewNetworkName from "../Shared/NewNetworkName";
import { Option } from "../../interface/Option";
import ListOfInsuranceplanName from "../Shared/ListOfInsuranceplanName";
import ActivitySelector from "../Shared/ActivityType";
import ListofActivityCode from "Pages/Shared/ListOfActivityCode";
import { ClaimValidationAxiosInstance } from "Network/ClaimValidation";
import { PatientRelationAxiosInstance } from "../../Network/PatientRelationAxiosInstance";
import PolicyNames from "../Shared/PolicyNames";
import VipPatientSelector from "Pages/Shared/VipPatient";
import ListOfProviderName from "../Shared/ListOfProviderName";
import SingleIcdMedicalCodeSearch from "../Shared/claimicd";
import ListOfDrugCode from "../Shared/DrugCode";
import SpecialtySelector from "../Shared/Specialty";
import ListOfDoctorName from "../Shared/Doctor";
import Vip from "../Shared/Vip";
import { Toaster } from "../../components/ui/toaster";
import { useToast } from "../../hooks/use-toast";

const GLOBAL_STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=DM+Mono:wght@400;500&display=swap');

  :root {
    --cv-bg:          #f0f4f8;
    --cv-surface:     #ffffff;
    --cv-surface-2:   #f7f9fc;
    --cv-border:      #dde3ec;
    --cv-border-focus:#3b6fd4;
    --cv-text:        #1a2235;
    --cv-muted:       #6b7a99;
    --cv-accent:      #3b6fd4;
    --cv-accent-soft: #eef2fb;
    --cv-success:     #22c55e;
    --cv-danger:      #ef4444;
    --cv-danger-soft: #fef2f2;
    --cv-warn-soft:   #fffbeb;
    --cv-radius:      10px;
    --cv-radius-sm:   6px;
    --cv-shadow:      0 1px 3px rgba(26,34,53,0.08), 0 4px 16px rgba(26,34,53,0.06);
    --cv-shadow-focus:0 0 0 3px rgba(59,111,212,0.18);
    --cv-font:        'DM Sans', sans-serif;
    --cv-mono:        'DM Mono', monospace;
    --cv-transition:  all 0.18s cubic-bezier(.4,0,.2,1);
  }

  .cv-wrap * { box-sizing: border-box; font-family: var(--cv-font); }
  .cv-field { display: flex; flex-direction: column; gap: 5px; }
  .cv-label { font-size: 11.5px; font-weight: 700; letter-spacing: 0.06em; color: #3a4560; text-transform: capitalize; }

  .cv-input, .cv-select {
    width: 100%; height: 40px; padding: 0 12px;
    border: 1.5px solid var(--cv-border);
    border-radius: var(--cv-radius-sm);
    background: var(--cv-surface); color: var(--cv-text);
    font-size: 13.5px; font-family: var(--cv-font);
    transition: var(--cv-transition); outline: none;
    appearance: none; -webkit-appearance: none;
  }
  .cv-input::placeholder { color: #aab2c4; }
  .cv-input:focus, .cv-select:focus {
    border-color: var(--cv-border-focus);
    box-shadow: var(--cv-shadow-focus); background: #fafcff;
  }
  .cv-input:disabled, .cv-select:disabled {
    background: #f0f2f7; color: #a0a9bf;
    cursor: not-allowed; border-color: #e4e9f0;
  }
  .cv-input[type="number"]::-webkit-inner-spin-button,
  .cv-input[type="number"]::-webkit-outer-spin-button { opacity: 0.4; }

  .cv-select-wrap { position: relative; }
  .cv-select-wrap::after {
    content: ''; pointer-events: none; position: absolute;
    right: 12px; top: 50%; transform: translateY(-50%);
    width: 0; height: 0;
    border-left: 5px solid transparent; border-right: 5px solid transparent;
    border-top: 5px solid var(--cv-muted);
  }

  .cv-section {
    background: var(--cv-surface); border: 1px solid var(--cv-border);
    border-radius: var(--cv-radius); padding: 22px 24px;
    margin-bottom: 16px; box-shadow: var(--cv-shadow);
  }
  .cv-section-title {
    font-size: 14px; font-weight: 700; color: var(--cv-text);
    margin: 0 0 18px 0; padding-bottom: 12px;
    border-bottom: 1px solid var(--cv-border);
    display: flex; align-items: center; gap: 8px;
    text-transform: capitalize;
  }
  .cv-section-title::before {
    content: ''; display: inline-block;
    width: 3px; height: 16px;
    background: var(--cv-accent); border-radius: 2px;
  }

  .cv-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px 20px; }

  .cv-table { width: 100%; border-collapse: collapse; font-size: 13px; margin-top: 4px; }
  .cv-table thead tr { background: var(--cv-surface-2); }
  .cv-table th {
    text-align: left; padding: 9px 12px; font-size: 11px;
    font-weight: 700; letter-spacing: 0.06em; text-transform: capitalize;
    color: var(--cv-muted); border-bottom: 1.5px solid var(--cv-border);
  }
  .cv-table td {
    padding: 9px 12px; border-bottom: 1px solid #f0f3f8;
    color: var(--cv-text); font-size: 13px;
  }
  .cv-table tbody tr:last-child td { border-bottom: none; }
  .cv-table tbody tr:hover { background: var(--cv-surface-2); }
  .cv-table .cv-mono { font-family: var(--cv-mono); font-size: 12px; color: #4a5568; }

  .cv-btn {
    display: inline-flex; align-items: center; justify-content: center;
    gap: 6px; height: 38px; padding: 0 18px;
    border-radius: var(--cv-radius-sm); font-size: 13px;
    font-weight: 600; cursor: pointer; border: none;
    transition: var(--cv-transition); white-space: nowrap;
    text-transform: capitalize;
  }
  .cv-btn-primary { background: var(--cv-accent); color: #fff; }
  .cv-btn-primary:hover { background: #2e5bb8; transform: translateY(-1px); box-shadow: 0 4px 12px rgba(59,111,212,0.3); }
  .cv-btn-primary:active { transform: translateY(0); }
  .cv-btn-primary:disabled { opacity: 0.55; cursor: not-allowed; transform: none; box-shadow: none; }
  .cv-btn-outline { background: transparent; color: var(--cv-accent); border: 1.5px solid var(--cv-accent); }
  .cv-btn-outline:hover { background: var(--cv-accent-soft); }
  .cv-btn-outline:disabled { opacity: 0.45; cursor: not-allowed; }
  .cv-btn-danger {
    background: transparent; color: var(--cv-danger);
    border: 1.5px solid #fca5a5; padding: 0 12px;
    height: 30px; font-size: 12px;
  }
  .cv-btn-danger:hover { background: var(--cv-danger-soft); border-color: var(--cv-danger); }
  .cv-btn-add {
    background: var(--cv-accent-soft); color: var(--cv-accent);
    border: 1.5px dashed var(--cv-border-focus); padding: 0 16px; height: 38px;
  }
  .cv-btn-add:hover { background: #e4ecfb; }

  .cv-steps { margin-bottom: 28px; }
  .cv-steps-track {
    display: flex; align-items: center;
    justify-content: space-between; position: relative; padding: 0 4px;
  }
  .cv-steps-line {
    position: absolute; top: 20px; left: 24px; right: 24px;
    height: 2px; background: var(--cv-border); z-index: 0;
  }
  .cv-steps-progress {
    position: absolute; top: 0; left: 0; height: 100%;
    background: var(--cv-accent); transition: width 0.4s ease; border-radius: 2px;
  }
  .cv-step {
    display: flex; flex-direction: column; align-items: center;
    gap: 6px; position: relative; z-index: 1; cursor: pointer;
  }
  .cv-step-circle {
    width: 40px; height: 40px; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    font-size: 13px; font-weight: 700; transition: var(--cv-transition);
    background: var(--cv-surface); border: 2px solid var(--cv-border); color: var(--cv-muted);
  }
  .cv-step.active .cv-step-circle,
  .cv-step.done .cv-step-circle {
    background: var(--cv-accent); border-color: var(--cv-accent); color: #fff;
    box-shadow: 0 0 0 4px rgba(59,111,212,0.15);
  }
  .cv-step-label { font-size: 11px; font-weight: 600; color: var(--cv-muted); letter-spacing: 0.04em; transition: var(--cv-transition); text-transform: capitalize; }
  .cv-step.active .cv-step-label,
  .cv-step.done .cv-step-label { color: var(--cv-accent); }

  .cv-alert-error {
    display: flex; align-items: center; gap: 8px;
    padding: 10px 14px; background: var(--cv-danger-soft);
    border: 1px solid #fca5a5; border-left: 3px solid var(--cv-danger);
    border-radius: var(--cv-radius-sm); font-size: 13px;
    color: #b91c1c; margin-bottom: 14px;
  }
  .cv-alert-success {
    padding: 12px 16px; background: #f0fdf4;
    border: 1px solid #86efac; border-left: 3px solid var(--cv-success);
    border-radius: var(--cv-radius-sm); font-size: 13.5px;
    color: #15803d; margin-top: 16px;
  }
  .cv-alert-fail {
    padding: 12px 16px; background: var(--cv-danger-soft);
    border: 1px solid #fca5a5; border-left: 3px solid var(--cv-danger);
    border-radius: var(--cv-radius-sm); font-size: 13.5px;
    color: #b91c1c; margin-top: 16px;
  }

  .cv-nav {
    display: flex; justify-content: space-between; align-items: center;
    margin-top: 20px; padding-top: 16px; border-top: 1px solid var(--cv-border);
  }

  .cv-badge {
    display: inline-flex; align-items: center;
    padding: 2px 8px; border-radius: 20px;
    font-size: 11px; font-weight: 600; white-space: nowrap;
  }

  .cv-vcard {
    border: 1px solid var(--cv-border); border-radius: var(--cv-radius);
    overflow: hidden; margin-bottom: 10px;
    box-shadow: 0 1px 3px rgba(26,34,53,0.06);
  }
  .cv-vcard-pass { border-left: 3px solid var(--cv-success); }
  .cv-vcard-fail { border-left: 3px solid var(--cv-danger); }
  .cv-vcard-header {
    display: flex; align-items: flex-start;
    gap: 10px; padding: 12px 14px; cursor: pointer;
  }
  .cv-vcard-header:hover { background: var(--cv-surface-2); }
  .cv-vcard-pass .cv-vcard-header { background: #f0fdf4; }
  .cv-vcard-fail .cv-vcard-header { background: #fef2f2; }
  .cv-vcard-children { border-top: 1px solid var(--cv-border); }
  .cv-vcard-child {
    display: flex; gap: 10px;
    padding: 10px 14px 10px 32px; border-bottom: 1px solid #f5f7fc;
  }
  .cv-vcard-child:last-child { border-bottom: none; }
  .cv-vcard-child.pass { background: #f9fffe; }
  .cv-vcard-child.fail { background: #fff9f9; }

  .cv-page-header { display: flex; align-items: center; gap: 10px; margin-bottom: 20px; }
  .cv-page-header h1 { font-size: 20px; font-weight: 700; color: var(--cv-text); margin: 0; text-transform: capitalize; }

  .cv-card {
    background: var(--cv-surface); border: 1px solid var(--cv-border);
    border-radius: 14px; padding: 28px; box-shadow: var(--cv-shadow);
    max-width: 100%; margin: 0;
  }

  .cv-mt-sm { margin-top: 10px; }
  .cv-mt-md { margin-top: 16px; }
  .cv-actions-row { display: flex; align-items: center; gap: 10px; margin-top: 14px; }

  .cv-claim-group-title {
    font-size: 13px; font-weight: 600; color: var(--cv-muted);
    margin-bottom: 10px; display: flex; gap: 12px; align-items: center;
    text-transform: capitalize;
  }
  .cv-claim-group-title span.id {
    background: var(--cv-accent-soft); color: var(--cv-accent);
    padding: 2px 10px; border-radius: 20px;
    font-size: 12px; font-family: var(--cv-mono);
  }

  @keyframes cv-spin { to { transform: rotate(360deg); } }
  .cv-spinner {
    display: inline-block; width: 14px; height: 14px;
    border: 2px solid rgba(255,255,255,0.4); border-top-color: #fff;
    border-radius: 50%; animation: cv-spin 0.7s linear infinite;
  }

  .cv-divider { height: 1px; background: var(--cv-border); margin: 18px 0; }

  .cv-obs-mono { font-family: var(--cv-mono); font-size: 11.5px; color: #4a5568; }
`;

const StyleInjector = () => <style dangerouslySetInnerHTML={{ __html: GLOBAL_STYLES }} />;

// ─── QA Automation IDs ───────────────────────────────────────────────────────
// Stable selectors for Claim Validation UI automation.
// These attributes do not change API calls, payloads, validation logic, or UI behavior.
const QA_PAGE_PREFIX = "claim-validation";

const qaSafe = (value: string | number | undefined | null) =>
  String(value ?? "unknown")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

const qaId = (suffix: string | number) => `${QA_PAGE_PREFIX}-${qaSafe(suffix)}`;

const qaAttrs = (suffix: string | number) => ({
  id: qaId(suffix),
  "data-testid": qaId(suffix),
  "data-qa": qaId(suffix),
});

const CvLabel = ({ children, qaKey }: { children: React.ReactNode; qaKey?: string }) => (
  <span className="cv-label" {...(qaKey ? qaAttrs(`label-${qaKey}`) : {})}>{children}</span>
);
const CvInput = ({
  type = "text", value, onChange, disabled, placeholder, onKeyDown, qaKey, testId,
}: {
  type?: string; value?: string | number;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean; placeholder?: string;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  qaKey?: string;
  testId?: string;
}) => {
  const generatedQaId = qaKey ? qaId(`input-${qaKey}`) : undefined;

  return (
    <input
      className="cv-input"
      type={type}
      value={value}
      onChange={onChange}
      disabled={disabled}
      placeholder={placeholder}
      onKeyDown={onKeyDown}
      id={generatedQaId}
      data-testid={testId ?? generatedQaId}
      data-qa={generatedQaId}
      data-qa-disabled={disabled ? "true" : "false"}
    />
  );
};
const CvSelect = ({
  value, onChange, disabled, children, qaKey, testId,
}: {
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  disabled?: boolean; children: React.ReactNode; qaKey?: string; testId?: string;
}) => {
  const generatedWrapperQaId = qaKey ? qaId(`select-wrapper-${qaKey}`) : undefined;
  const generatedSelectQaId = qaKey ? qaId(`select-${qaKey}`) : undefined;

  return (
    <div
      className="cv-select-wrap"
      id={generatedWrapperQaId}
      data-testid={generatedWrapperQaId}
      data-qa={generatedWrapperQaId}
    >
      <select
        className="cv-select"
        value={value}
        onChange={onChange}
        disabled={disabled}
        id={generatedSelectQaId}
        data-testid={testId ?? generatedSelectQaId}
        data-qa={generatedSelectQaId}
        data-qa-disabled={disabled ? "true" : "false"}
      >
        {children}
      </select>
    </div>
  );
};

// ─── Types ────────────────────────────────────────────────────────────────────
interface DiagnosisOption extends Option { type?: string; }
interface DrugRow { drugCode: string; total: number; }

interface ActivityRow {
  id: number;
  type: string;
  codes: Option[];
  quantity: number;
  start: string;
  approvalCode: string;
  toothNumbers: string[];
}

// ─── Main Component ───────────────────────────────────────────────────────────
const ClaimValidation = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 6;
  const [isLoading, setIsLoading] = useState(false);
  const [expandedRows, setExpandedRows] = useState<Set<string>>(new Set());

  const toggleRowExpansion = (rowKey: string) => {
    const s = new Set(expandedRows);
    s.has(rowKey) ? s.delete(rowKey) : s.add(rowKey);
    setExpandedRows(s);
  };

  const token = localStorage.getItem("token") || "";

  const [patientGender, setPatientGender] = useState("female");
  const [patientAge, setPatientAge] = useState<number | undefined>();
  const [patients, setPatients] = useState<Option[]>([]);
  const [date, setDate] = useState("");
  const [payers, setPayers] = useState([""]);
  const [providers, setProviders] = useState<Option[]>([]);
  const [network, setNetworks] = useState<Option[]>([]);
  const [insurancePlans, setInsuranceplan] = useState<Option[]>([]);
  const [relation_id, setRelationIds] = useState([1]);
  const [claimID, setClaimID] = useState<number | undefined>();
  const [policy, setPolicy] = useState<Option[]>([]);
  const [doctor, setDoctor] = useState<Option[]>([]);
  const [vip, setVip] = useState<Option[]>([]);
  const [primaryDiagnoses, setprimaryDiagnoses] = useState<DiagnosisOption | null>(null);
  const [secondaryDiagnoses, setsecondaryDiagnoses] = useState<DiagnosisOption[]>([]);
  const [activities, setActivities] = useState<ActivityRow[]>([]);
  const [approvalCode, setApprovalCode] = useState<string>("");
  const [editingActivityIndex, setEditingActivityIndex] = useState<number | null>(null);
  const [diagnosisSearchKey, setDiagnosisSearchKey] = useState(0);
  const { toast } = useToast();

  const activityTypeMapping: { [key: string]: string } = {
    CPT: "3", HCPCS: "4", DRUGS: "5", DENTAL: "6",
  };

  const getNowFormatted = () => {
    const d = new Date();
    d.setDate(d.getDate() - 1);
    return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
  };

  const emptyActivity = (): Omit<ActivityRow, "id"> => ({
    type: "", codes: [], quantity: 1,
    start: getNowFormatted(), approvalCode: "", toothNumbers: [],
  });

  const [currentActivity, setCurrentActivity] = useState<ActivityRow>({ id: 1, ...emptyActivity() });

  // ── Tooth numbers: add-one-at-a-time UI, only shown for Dental ──
  const [toothNumberDraft, setToothNumberDraft] = useState<string>("");
  const [currentToothNumbers, setCurrentToothNumbers] = useState<string[]>([]);

  const addToothNumber = () => {
    const trimmed = toothNumberDraft.trim();
    if (trimmed && !currentToothNumbers.includes(trimmed)) {
      setCurrentToothNumbers((prev) => [...prev, trimmed]);
      setToothNumberDraft("");
    }
  };

  const removeToothNumber = (num: string) => {
    setCurrentToothNumbers((prev) => prev.filter((n) => n !== num));
  };

  const [addCount, setAddCount] = useState(0);
  const [DrugCode, setDrugCode] = useState<Option[]>([]);
  const [specialty, setSpecialty] = useState<Option[]>([]);
  const [total, setTotal] = useState<number | undefined>(undefined);
  const [drugsTableRows, setDrugsTableRows] = useState<DrugRow[]>([]);

  const [encounter, setEncounter] = useState({
    FacilityID: "", Type: "1", PatientID: "", Start: "", End: "",
    StartType: "", EndType: "", TransferSource: "", TransferDestination: "",
  });

  const [memberId, setMemberId] = useState("");
  const [patientPassport, setPatientPassport] = useState("");
  const [nationalIDNumber, setNationalIDNumber] = useState("");
  const [gross, setGross] = useState("");
  const [patientShare, setPatientShare] = useState("");
  const [net, setNet] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [type, setType] = useState("");

  const [clearNetworks, setClearNetworks] = useState(false);
  const [clearInsuranceplan, setClearInsuranceplan] = useState(false);
  const [validationResults, setValidationResults] = useState<any[]>([]);
  const [responseMessage, setResponseMessage] = useState("");
  const [IcdDescription, setIcdDescription] = useState("");
  const [clearDrugCode, setClearDrugCode] = useState(false);
  const [clearsecondaryDiagnoses, setClearSecondaryDiagnoses] = useState(false);
  const [clearprimaryDiagnoses, setClearprimaryDiagnoses] = useState(false);
  const [selectedActivities, setSelectedActivities] = useState<Option[]>([]);
  const [clearPolicy, setClearPolicy] = useState(false);
  const [clearProvider, setClearProvider] = useState(false);
  const [clearPatient, setClearPatient] = useState(false);
  const [clearSpecialty, setClearSpecialty] = useState(false);
  const [clearDoctor, setClearDoctor] = useState(false);
  const [diagnosisError, setDiagnosisError] = useState("");
  const [clearVip, setClearVip] = useState(false);
  const [isPatientSelected, setIsPatientSelected] = useState(false);
  const [activityError, setActivityError] = useState("");
  // ─── QA Automation: nested shared inputs/dropdowns ──────────────────────────
  // Some controls are rendered inside shared components / react-select.
  // We attach stable selectors to the actual inner input/select element too,
  // without changing API, payload, validation logic, or UI behavior.
  const applyNestedControlQaAttrs = () => {
    const setControlQaAttrs = (wrapperQaId: string, controlTestId: string) => {
      const wrapper = document.getElementById(wrapperQaId);
      const control = wrapper?.querySelector("input, select, textarea") as
        | HTMLInputElement
        | HTMLSelectElement
        | HTMLTextAreaElement
        | null;

      if (control) {
        control.setAttribute("id", controlTestId);
        control.setAttribute("data-testid", controlTestId);
        control.setAttribute("data-qa", controlTestId);
      }
    };

    // Step 1
    setControlQaAttrs(qaId("field-patient-selector"), "claim-validation-input-patient");

    // Step 2
    setControlQaAttrs(qaId("field-provider-selector"), "claim-validation-input-provider");
    setControlQaAttrs(qaId("field-insurance-plan-selector"), "claim-validation-input-insurance-plan");
    setControlQaAttrs(qaId("field-network-selector"), "claim-validation-input-network");
    setControlQaAttrs(qaId("field-policy-selector"), "claim-validation-input-policy");
    setControlQaAttrs(qaId("field-doctor-selector"), "claim-validation-input-doctor");
    setControlQaAttrs(qaId("field-vip-selector"), "claim-validation-input-vip");
    setControlQaAttrs(qaId("field-specialty-selector"), "claim-validation-input-specialty");

    // Step 3
    setControlQaAttrs(qaId("field-diagnosis-search"), "claim-validation-input-icd");

    // Step 4
    setControlQaAttrs(qaId("field-activity-type-selector"), "claim-validation-select-activity-type");
    setControlQaAttrs(qaId("field-activity-code-selector"), "claim-validation-input-activity-code");
    setControlQaAttrs(qaId("field-drug-code-selector"), "claim-validation-input-drug-code");
  };

  useEffect(() => {
    const timer = window.setTimeout(applyNestedControlQaAttrs, 0);
    return () => window.clearTimeout(timer);
  }, [
    currentStep,
    diagnosisSearchKey,
    addCount,
    currentActivity.type,
    clearPatient,
    clearProvider,
    clearPolicy,
    clearNetworks,
    clearInsuranceplan,
    clearDoctor,
    clearVip,
    clearSpecialty,
    clearDrugCode,
  ]);

  const stepNames = ["Patient Info", "Insurance", "Diagnosis", "Activities & Drugs", "Encounter Info", "Results"];

  const handleNext = async () => {
    if (currentStep === 3 && !primaryDiagnoses) { setDiagnosisError("Please add at least one diagnosis code before proceeding."); return; }
    if (currentStep === 4 && activities.length === 0) { setActivityError("Please add at least one activity before proceeding."); return; }
    if (currentStep < totalSteps) { setCurrentStep(currentStep + 1); setDiagnosisError(""); setActivityError(""); }
  };
  const handleValidateAndNext = async () => { await handleGenerate(); setCurrentStep(6); };

  const handlePrevious = () => {
    if (currentStep <= 1) return;

    setCurrentStep(currentStep - 1);
    setDiagnosisError("");
    setActivityError("");
  };

  const handleStepClick = async (step: number) => {
    setCurrentStep(step);
    setDiagnosisError("");
    setActivityError("");
  };

  const fetchPatientData = async (patientId: string | number) => {
    try {
      const response = await PatientRelationAxiosInstance.get("getpatient");
      if (response.data.success && response.data.result) {
        const patient = response.data.result.find((p: any) => p.full_name === patientId);
        if (patient) {
          setPatientGender(patient.gender?.toLowerCase() || "female");
          if (patient.patient_dob) {
            const birthDate = new Date(patient.patient_dob);
            const today = new Date();
            let age = today.getFullYear() - birthDate.getFullYear();
            const monthDiff = today.getMonth() - birthDate.getMonth();
            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) age--;
            setPatientAge(age);
          } else setPatientAge(undefined);
          setMemberId(patient.member_id?.toString() || "");
          setNationalIDNumber(patient.national_id?.toString() || "");
          setPatientPassport(patient.patient_passport?.toString() || "");
          if (patient.patient_dob) {
            const dob = new Date(patient.patient_dob);
            setDateOfBirth(`${dob.toISOString().split("T")[0]} 00:00`);
          } else setDateOfBirth("");
          if (patient.policy && Array.isArray(patient.policy) && patient.policy.length > 0) {
            const policyOptions = patient.policy.map((p: any) => ({
              value: String(p.policy_id || p.Policy_id || p.id || ""),
              label: String(p.policy_name || p.Policy_name || p.name || ""),
            })).filter((p: any) => p.label && p.value);
            if (policyOptions.length > 0) { setPolicy(policyOptions); setClearPolicy(false); }
          } else setPolicy([]);
        }
      }
    } catch (error) { console.error("Error fetching patient data:", error); }
  };

  const handleReset = () => {
    setCurrentStep(1); setPatients([]); setPatientGender("female"); setPatientAge(undefined);
    setPayers([""]); setProviders([]); setNetworks([]); setDate(""); setDrugCode([]);
    setSpecialty([]); setDoctor([]); setVip([]); setTotal(undefined); setInsuranceplan([]);
    setRelationIds([1]); setClaimID(undefined); setprimaryDiagnoses(null); setsecondaryDiagnoses([]);
    setSelectedActivities([]); setActivities([]);
    setCurrentActivity({ id: 1, ...emptyActivity() });
    setCurrentToothNumbers([]);
    setToothNumberDraft("");
    setApprovalCode("");
    setClearprimaryDiagnoses(true); setClearSecondaryDiagnoses(true); setClearPatient(true);
    setClearProvider(true); setClearPolicy(true); setClearNetworks(true); setClearInsuranceplan(true);
    setValidationResults([]); setDrugsTableRows([]); setClearDrugCode(true); setClearDoctor(true); setClearVip(true);
    setEncounter({ FacilityID: "", Type: "1", PatientID: "", Start: "", End: "", StartType: "", EndType: "", TransferSource: "", TransferDestination: "" });
    setMemberId(""); setPatientPassport(""); setNationalIDNumber(""); setGross("");
    setPatientShare(""); setNet(""); setDateOfBirth(""); setType(""); setIsPatientSelected(false); setResponseMessage("");
    setTimeout(() => {
      setClearPatient(false); setClearProvider(false); setClearPolicy(false); setClearNetworks(false);
      setClearInsuranceplan(false); setClearprimaryDiagnoses(false); setClearSecondaryDiagnoses(false);
      setClearDrugCode(false); setClearSpecialty(false); setClearDoctor(false); setClearVip(false);
    }, 0);
  };

  const handleNetworkChange = (s: Option | Option[] | null) => { if (!s) { setNetworks([]); return; } setNetworks(Array.isArray(s) ? [s[s.length - 1]] : [s]); };
  const handlePolicyChange = (s: Option | Option[] | null) => { if (!s) { setPolicy([]); return; } if (Array.isArray(s)) setPolicy(s.length === 0 ? [] : [s[s.length - 1]]); else setPolicy([s]); };
  const handlePatientChange = async (s: Option[] | Option | null) => {
    const selectedPatient = Array.isArray(s)
      ? s.length > 0
        ? s[s.length - 1]
        : null
      : s;

    if (!selectedPatient) {
      setPatients([]);
      setPatientGender("female");
      setPatientAge(undefined);
      setMemberId("");
      setNationalIDNumber("");
      setPatientPassport("");
      setDateOfBirth("");
      setPolicy([]);
      setIsPatientSelected(false);
      return;
    }

    setPatients([selectedPatient]);
    await fetchPatientData(selectedPatient.value);
    setIsPatientSelected(true);
  };
  const handleProviderChange = (s: Option | Option[] | null) => { if (!s) { setProviders([]); return; } setProviders(Array.isArray(s) ? [s[s.length - 1]] : [s]); };
  const handleInsuranceplanChange = (s: Option | Option[] | null) => { if (!s) { setInsuranceplan([]); return; } setInsuranceplan(Array.isArray(s) ? [s[s.length - 1]] : [s]); };
  const handleSpecialtyChange = (s: Option | Option[] | null) => { if (!s) { setSpecialty([]); return; } setSpecialty(Array.isArray(s) ? [s[s.length - 1]] : [s]); };
const handleDoctorChange = (s: Option | Option[] | null) => { 
  if (!s) { setDoctor([]); return; } 
  setDoctor(Array.isArray(s) ? s : [s]); 
};
  const handleVipChange = (s: Option | Option[] | null) => { if (!s) { setVip([]); return; } setVip(Array.isArray(s) ? [s[s.length - 1]] : [s]); };

  const handleDeleteRow = (index: number) => setDrugsTableRows((p) => p.filter((_, i) => i !== index));
  const handleAddDrug = () => {
    if (DrugCode.length > 0 && DrugCode[0]?.value && total !== undefined) {
      setDrugsTableRows((p) => [...p, { drugCode: String(DrugCode[0].value), total }]);
      setDrugCode([]); setTotal(undefined); setClearDrugCode(false);
    }
  };

  const removeActivity = (index: number) => {
    setActivities((p) => p.filter((_, i) => i !== index));
    if (editingActivityIndex === index) cancelEditActivity();
    else if (editingActivityIndex !== null && index < editingActivityIndex) {
      setEditingActivityIndex(editingActivityIndex - 1);
    }
  };

  const handleActivityTypeChange = (t: string) => {
    setCurrentActivity({ ...currentActivity, type: t, codes: [] });
    // Clear tooth numbers whenever the type changes away from Dental
    if (t?.toLowerCase() !== "dental") {
      setCurrentToothNumbers([]);
      setToothNumberDraft("");
    }
  };

  const startEditActivity = (index: number) => {
    const activityToEdit = activities[index];
    setCurrentActivity({ ...activityToEdit, codes: [...activityToEdit.codes] });
    setCurrentToothNumbers([...activityToEdit.toothNumbers]);
    setToothNumberDraft("");
    setEditingActivityIndex(index);
    setActivityError("");
  };

  const cancelEditActivity = () => {
    setCurrentActivity({ id: 1, ...emptyActivity() });
    setCurrentToothNumbers([]);
    setToothNumberDraft("");
    setEditingActivityIndex(null);
    setAddCount((p) => p + 1);
    setActivityError("");
  };

const addActivityToTable = () => {
  console.log("[DEBUG] type:", JSON.stringify(currentActivity.type), "codes:", currentActivity.codes.length, "currentToothNumbers:", currentToothNumbers);
  if (currentActivity.type && currentActivity.codes.length > 0) {
    const isDental = currentActivity.type?.toLowerCase() === "dental";
    const toothNumbersToSave = isDental ? currentToothNumbers : [];
    console.log("[DEBUG] isDental:", isDental, "toothNumbersToSave:", toothNumbersToSave);

    if (editingActivityIndex !== null) {
      setActivities((prev) =>
        prev.map((a, idx) =>
          idx === editingActivityIndex ? { ...currentActivity, toothNumbers: toothNumbersToSave } : a
        )
      );
      setCurrentActivity({ id: 1, ...emptyActivity() });
      setCurrentToothNumbers([]);
      setToothNumberDraft("");
      setEditingActivityIndex(null);
      setAddCount((p) => p + 1);
      setActivityError("");
      return;
    }

    setActivities((prev) => [...prev, { ...currentActivity, toothNumbers: toothNumbersToSave }]);
    console.log("[DEBUG] activity added with toothNumbers:", toothNumbersToSave);
    setCurrentActivity({ id: 1, ...emptyActivity() });
    setCurrentToothNumbers([]);
    setToothNumberDraft("");
    setAddCount((p) => p + 1);
    setActivityError("");
  }
};

  const handleGenerate = async () => {
    const ValuesNetwork = Array.isArray(network) ? network.map((o) => o.label.replace(/^\(\d+\)\s*/, "")) : [];
    const ValuesInsurancePlan = Array.isArray(insurancePlans) ? insurancePlans.map((o) => o.label.replace(/^\(\d+\)\s*/, "")) : [];
    const policyData = policy.map((p: any) => {
      if (typeof p === "object" && p.Policy_id) return { id: p.id || 0, Policy_id: p.Policy_id, Policy_name: p.Policy_name, plans: p.plans || [] };
      else if (typeof p === "object" && p.value) return { id: p.value.id || 0, Policy_id: p.value.Policy_id || "", Policy_name: p.value.Policy_name || "", plans: p.value.plans || [] };
      else return { id: 1, Policy_id: "", Policy_name: "", plans: [] };
    });
    const ValuesProvider = providers.map((o: any) => {
      const parts = o.label.split(") "); const providerName = parts.length > 1 ? parts[1] : o.label;
      return { Provider_id: o.providerId || o.value, Provider_name: providerName.trim() };
    });
    const ValuesPatient = patients.map((o) => o.value);
    const normalizedPayers = payers.filter((p) => typeof p === "string" && p.trim() !== "");
    const ValuesSpecialty = specialty.map((o) => o.value);
    const ValuesDoctor = Array.isArray(doctor) ? doctor.map((o) => { const m = o.label.match(/^\(\d+\)\s*(.+)$/); return m ? m[1].trim() : o.label.trim(); }) : [];
    const ValuesDrug = drugsTableRows.map((r) => r.drugCode);
    const ValuesVip = Array.isArray(vip) ? vip.map((o) => o.label.replace(/^\(\d+\)\s*/, "")) : [];
    const ValuesTotal = drugsTableRows.map((r) => r.total);

    const requestData = {
      data: [{
        patientData: { patientGender, patientAge }, patients: ValuesPatient, policy: policyData,
        payer: normalizedPayers, vip: ValuesVip, provider: ValuesProvider, network: ValuesNetwork,
        insurancePlan: ValuesInsurancePlan, doctor: ValuesDoctor, current_date: date, relation_id,
        claim_ID: claimID, primary_diagnosis_code: primaryDiagnoses?.value || null,
        secondery_diagnosis_codes: secondaryDiagnoses.map((o) => o.value),
        activities: activities.map((a, idx) => ({
          id: idx + 1,
          codes: a.codes.map((c) => c.value),
          type: activityTypeMapping[a.type.toLowerCase()] || a.type,
          quantity: a.quantity,
          start: a.start,
          approvalCode: a.approvalCode,
          toothNumbers: a.toothNumbers,
        })),
        Encounter: [encounter], memberId, patientPassport, nationalIDNumber,
        gross, patientShare, net, dateOfBirth, type,
        drugs: ValuesDrug, specialty: ValuesSpecialty, total: ValuesTotal,
      }],
      token,
    };

    try {
      setIsLoading(true); setValidationResults([]); setResponseMessage("");
      const response = await ClaimValidationAxiosInstance.post("validate-all", requestData, {
        headers: { "Content-Type": "application/json" },
      });
      if (response.data.validations) setValidationResults(response.data.validations);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const backendError = error.response?.data?.error;
        if (backendError) {
          toast({ title: "Error", description: backendError, variant: "destructive" });
        }
        setValidationResults(error.response?.data?.validations || [{ name: "Unknown Error", result: { success: false, error: (error as any).message } }]);
      } else {
        setResponseMessage("An unexpected error occurred.");
      }
    } finally { setIsLoading(false); }
  };

  // ─── Validation card renderer ─────────────────────────────────────────────
  const renderValidationCard = (validation: any, idx: number, claimId: any) => {
    const result = typeof validation.result === "string" ? { success: false, message: validation.result } : validation.result || {};
    const validationType = validation.type || result.relation_Type || result.error_type || result.type || null;
    const validationLevel = validation.level || result.level || null;
    const validationElement = validation.element || result.element || null;
    const validationDomain = validation.domain || result.domain || null;
    const validationDenial = validation.denial || result.denial || null;
    const validationCode = Array.isArray(validation.code) ? validation.code.join(", ") : validation.code || result.activityCode || result.code || null;
    const validationId = validation.id || result.activityid || null;
    const mainBenefit = validation.benefit || result.benefit || null;
    const subBenefit = validation.usedBenefit || result.usedBenefit || null;
    const detailsText = typeof validation.result === "string" ? validation.result : result.message || result.error || (result.validationErrors && result.validationErrors.map((e: any) => `${e.Type}: ${e.Message}`).join(" | ")) || null;

    const TagRow = ({ v, res }: any) => (
      <div style={{ display: "flex", flexWrap: "wrap", gap: 5, marginTop: 6 }}>
        {mainBenefit && <span className="cv-badge" style={{ background: "#eef2fb", color: "#3b6fd4" }}>Benefit: {mainBenefit}</span>}
        {subBenefit && <span className="cv-badge" style={{ background: "#f3f0ff", color: "#7c3aed" }}>Sub: {subBenefit}</span>}
        {validationId && <span className="cv-badge" style={{ background: "#f3f4f6", color: "#374151", fontFamily: "var(--cv-mono)" }}>ID: {validationId}</span>}
        {validationCode && <span className="cv-badge" style={{ background: "#f3f4f6", color: "#374151", fontFamily: "var(--cv-mono)" }}>Code: {res.isActivityError ? validationCode : (res.diagnosisCode || validationCode)}</span>}
        {validationType && <span className="cv-badge" style={{ background: "#fffbeb", color: "#b45309" }}>{validationType}</span>}
        {validationLevel && <span className="cv-badge" style={{ background: "#eef2fb", color: "#3730a3" }}>Level: {validationLevel}</span>}
        {validationElement && <span className="cv-badge" style={{ background: "#fdf2f8", color: "#9d174d" }}>{validationElement}</span>}
        {validationDomain && <span className="cv-badge" style={{ background: "#f0fdfa", color: "#0f766e" }}>{validationDomain}</span>}
        {validationDenial && validationDenial !== "N/A" && <span className="cv-badge" style={{ background: "#fef2f2", color: "#dc2626" }}>Denial: {validationDenial}</span>}
      </div>
    );

    if (validation.name === "SayanaValidation" && result.isParent && result.children?.length > 0) {
      const rowKey = `${claimId || "unknown"}-${validation.code}-${idx}`;
      const isExpanded = expandedRows.has(rowKey);
      const allChildrenPassed = result.children.every((child: any) => child.message === "PASS");
      return (
        <div key={`card-${idx}`} id={qaId(`validation-parent-card-${idx}`)} data-testid={qaId(`validation-parent-card-${idx}`)} data-qa={qaId(`validation-parent-card-${idx}`)} data-validation-name={validation.name} data-validation-passed={allChildrenPassed ? "true" : "false"} className={`cv-vcard ${allChildrenPassed ? "cv-vcard-pass" : "cv-vcard-fail"}`}>
          <div id={qaId(`validation-parent-card-${idx}-header`)} data-testid={qaId(`validation-parent-card-${idx}-header`)} data-qa={qaId(`validation-parent-card-${idx}-header`)} data-expanded={isExpanded ? "true" : "false"} className="cv-vcard-header" onClick={() => toggleRowExpansion(rowKey)}>
            <span style={{ fontSize: 18, flexShrink: 0 }}>{allChildrenPassed ? "✅" : "❌"}</span>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                <span style={{ fontWeight: 700, fontSize: 13, color: "var(--cv-text)" }}>{validation.name}</span>
                {result.errorType && <span className="cv-badge" style={{ background: "#eef2fb", color: "#3b6fd4" }}>{result.errorType}</span>}
                {result.priority != null && <span className="cv-badge" style={{ background: "#f3f4f6", color: "#374151" }}>Priority: {result.priority}</span>}
                <span style={{ marginLeft: "auto", color: "var(--cv-muted)", fontSize: 12 }}>{isExpanded ? "▲" : "▼"}</span>
              </div>
              <TagRow v={validation} res={result} />
              {detailsText && <p style={{ margin: "6px 0 0", fontSize: 12, color: "var(--cv-muted)" }}>{detailsText}</p>}
            </div>
          </div>
          {isExpanded && (
            <div className="cv-vcard-children">
              {result.children.map((child: any, childIdx: number) => {
                const childId = child.isActivityError ? child.activityId : child.diagnosisId;
                const childCode = child.isActivityError ? child.activityCode : child.diagnosisCode;
                const childPassed = child.message === "PASS";
                return (
                  <div key={`child-${childIdx}`} id={qaId(`validation-child-${idx}-${childIdx}`)} data-testid={qaId(`validation-child-${idx}-${childIdx}`)} data-qa={qaId(`validation-child-${idx}-${childIdx}`)} data-validation-child-passed={childPassed ? "true" : "false"} className={`cv-vcard-child ${childPassed ? "pass" : "fail"}`}>
                    <span style={{ fontSize: 15, flexShrink: 0 }}>{childPassed ? "✅" : "❌"}</span>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 11, color: "var(--cv-muted)", marginBottom: 4 }}>└ {validation.name} ({child.isActivityError ? "Activity" : "Diagnosis"} Child)</div>
                      <div style={{ display: "flex", flexWrap: "wrap", gap: 5 }}>
                        {childId && <span className="cv-badge" style={{ background: "#f3f4f6", color: "#374151", fontFamily: "var(--cv-mono)" }}>ID: {childId}</span>}
                        {childCode && <span className="cv-badge" style={{ background: "#f3f4f6", color: "#374151", fontFamily: "var(--cv-mono)" }}>Code: {childCode}</span>}
                        {(child.relationType || child.errorType) && <span className="cv-badge" style={{ background: "#fffbeb", color: "#b45309" }}>{child.relationType || child.errorType}</span>}
                        {child.level && <span className="cv-badge" style={{ background: "#eef2fb", color: "#3730a3" }}>Level: {child.level}</span>}
                        {child.element && <span className="cv-badge" style={{ background: "#fdf2f8", color: "#9d174d" }}>{child.element}</span>}
                        {child.domain && <span className="cv-badge" style={{ background: "#f0fdfa", color: "#0f766e" }}>{child.domain}</span>}
                      </div>
                      {child.message && child.message !== "PASS" && <p style={{ margin: "4px 0 0", fontSize: 11.5, color: "var(--cv-muted)" }}>{child.message}</p>}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      );
    }

    const passed = result.message === "PASS" || result.success === true;
    return (
      <div key={`card-${idx}`} id={qaId(`validation-card-${idx}`)} data-testid={qaId(`validation-card-${idx}`)} data-qa={qaId(`validation-card-${idx}`)} data-validation-name={validation.name} data-validation-passed={passed ? "true" : "false"} className={`cv-vcard ${passed ? "cv-vcard-pass" : "cv-vcard-fail"}`}>
        <div id={qaId(`validation-card-${idx}-header`)} data-testid={qaId(`validation-card-${idx}-header`)} data-qa={qaId(`validation-card-${idx}-header`)} className="cv-vcard-header" style={{ cursor: "default" }}>
          <span style={{ fontSize: 18, flexShrink: 0 }}>{passed ? "✅" : "❌"}</span>
          <div style={{ flex: 1, minWidth: 0 }}>
            <span style={{ fontWeight: 700, fontSize: 13, color: "var(--cv-text)" }}>{validation.name}</span>
            <TagRow v={validation} res={result} />
            {detailsText && <p style={{ margin: "6px 0 0", fontSize: 12, color: "var(--cv-muted)" }}>{detailsText}</p>}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div
      {...qaAttrs("page")}
      className="cv-wrap"
      style={{ padding: "80px 16px 24px", background: "var(--cv-bg)", minHeight: "100vh" }}
      data-current-step={currentStep}
      data-total-steps={totalSteps}
      data-is-loading={isLoading ? "true" : "false"}
    >
      <StyleInjector />
      <div {...qaAttrs("card")} className="cv-card">
        <div {...qaAttrs("page-header")} className="cv-page-header" style={{ marginBottom: 20, paddingBottom: 16, borderBottom: "1px solid var(--cv-border)" }}>
          <h1 {...qaAttrs("page-title")}>Claim Validation</h1>
        </div>

        {/* Steps */}
        <div {...qaAttrs("steps")} className="cv-steps">
          <div {...qaAttrs("steps-track")} className="cv-steps-track">
            <div {...qaAttrs("steps-line")} className="cv-steps-line">
              <div {...qaAttrs("steps-progress")} className="cv-steps-progress" style={{ width: `${((currentStep - 1) / (totalSteps - 1)) * 100}%` }} />
            </div>
            {Array.from({ length: totalSteps }, (_, i) => i + 1).map((step) => (
              <div
                key={step}
                id={qaId(`step-${step}`)}
                data-testid={qaId(`step-${step}`)}
                data-qa={qaId(`step-${step}`)}
                data-step-number={step}
                data-step-name={stepNames[step - 1]}
                data-step-active={currentStep === step ? "true" : "false"}
                data-step-done={currentStep > step ? "true" : "false"}
                className={`cv-step ${currentStep === step ? "active" : currentStep > step ? "done" : ""}`}
                onClick={() => void handleStepClick(step)}
              >
                <div {...qaAttrs(`step-${step}-circle`)} className="cv-step-circle">{step}</div>
                <span {...qaAttrs(`step-${step}-label`)} className="cv-step-label">{stepNames[step - 1]}</span>
              </div>
            ))}
          </div>
        </div>

        <div>
          {/* ── Step 1: Patient Info ── */}
          {currentStep === 1 && (
            <div {...qaAttrs("section-patient-information")} className="cv-section">
              <h2 {...qaAttrs("section-title-patient-information")} className="cv-section-title">Patient Information</h2>
              <div className="cv-grid">
                <div className="cv-field">
                  <CvLabel qaKey="patient">Patient</CvLabel>
                  {patients.length > 0 ? (
                    <div
                      {...qaAttrs("selected-patient-field")}
                      className="cv-input"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 10,
                        paddingRight: 10,
                        background: "#ffffff",
                        borderColor: "var(--cv-border-focus)",
                        boxShadow: "var(--cv-shadow-focus)",
                      }}
                    >
                      <span
                        {...qaAttrs("selected-patient-value")}
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          maxWidth: "calc(100% - 34px)",
                          padding: "5px 10px",
                          borderRadius: 5,
                          background: "var(--cv-accent)",
                          color: "#ffffff",
                          fontSize: 13,
                          fontWeight: 600,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                        title={patients[0]?.label}
                      >
                        {patients[0]?.label}
                      </span>

                      <button
                        {...qaAttrs("btn-remove-selected-patient")}
                        type="button"
                        aria-label="Remove selected patient"
                        title="Remove selected patient"
                        onClick={() => handlePatientChange([])}
                        style={{
                          width: 26,
                          height: 26,
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          border: "none",
                          borderRadius: 6,
                          background: "transparent",
                          color: "#64748b",
                          fontSize: 19,
                          fontWeight: 700,
                          cursor: "pointer",
                          flexShrink: 0,
                        }}
                      >
                        ×
                      </button>
                    </div>
                  ) : (
                    <div
                      id={qaId("field-patient-selector")}
                      data-testid={qaId("field-patient-selector")}
                      data-qa={qaId("field-patient-selector")}
                    >
                      <VipPatientSelector
                        qaIdPrefix={qaId("patient")}
                        defaultValue={[]}
                        onChange={handlePatientChange}
                        clear={clearPatient}
                      />
                    </div>
                  )}
                </div>
                <div className="cv-field">
                  <CvLabel qaKey="claim-id">Claim ID</CvLabel>
                  <CvInput qaKey="claim-id" testId="input-claim-id" type="number" value={claimID ?? ""} onChange={(e) => setClaimID(e.target.value === "" ? undefined : Number(e.target.value))} placeholder="Enter claim ID" />
                </div>
                <div className="cv-field">
                  <CvLabel qaKey="gender">Gender</CvLabel>
                  <CvSelect qaKey="gender" value={patientGender} onChange={(e) => setPatientGender(e.target.value)} disabled={isPatientSelected}>
                    <option value="female">Female</option>
                    <option value="male">Male</option>
                  </CvSelect>
                </div>
                <div className="cv-field">
                  <CvLabel qaKey="member-id">Member ID</CvLabel>
                  <CvInput qaKey="member-id" value={memberId} onChange={(e) => setMemberId(e.target.value)} disabled={isPatientSelected} placeholder="Enter member ID" />
                </div>
                <div className="cv-field">
                  <CvLabel qaKey="patient-passport">Patient Passport</CvLabel>
                  <CvInput qaKey="patient-passport" value={patientPassport} onChange={(e) => setPatientPassport(e.target.value)} disabled={isPatientSelected} placeholder="Enter passport number" />
                </div>
                <div className="cv-field">
                  <CvLabel qaKey="national-id-number">National ID Number</CvLabel>
                  <CvInput qaKey="national-id-number" value={nationalIDNumber} onChange={(e) => setNationalIDNumber(e.target.value)} disabled={isPatientSelected} placeholder="Enter national ID" />
                </div>
                <div className="cv-field">
                  <CvLabel qaKey="date-of-birth">Date of Birth</CvLabel>
                  <CvInput qaKey="date-of-birth" type="date" value={dateOfBirth ? dateOfBirth.split(" ")[0] : ""} onChange={(e) => setDateOfBirth(e.target.value ? `${e.target.value} 00:00` : "")} disabled={isPatientSelected} />
                </div>
                <div className="cv-field">
                  <CvLabel qaKey="current-date">Current Date</CvLabel>
                  <CvInput qaKey="current-date" type="date" value={date ? date.split(" ")[0] : ""} onChange={(e) => setDate(e.target.value ? `${e.target.value} 00:00` : "")} />
                </div>
              </div>
            </div>
          )}

          {/* ── Step 2: Insurance ── */}
          {currentStep === 2 && (
            <div {...qaAttrs("section-insurance-information")} className="cv-section">
              <h2 {...qaAttrs("section-title-insurance-information")} className="cv-section-title">Insurance Information</h2>
              <div className="cv-grid">
                <div {...qaAttrs("field-provider")} className="cv-field"><CvLabel qaKey="provider">Providers</CvLabel><div
                    id={qaId("field-provider-selector")}
                    data-testid={qaId("field-provider-selector")}
                    data-qa={qaId("field-provider-selector")}
                  ><ListOfProviderName qaIdPrefix={qaId("provider")} defaultValue={providers} onChange={handleProviderChange} clear={clearProvider} /></div></div>
                <div {...qaAttrs("field-insurance-plan")} className="cv-field"><CvLabel qaKey="insurance-plan">Insurance Plan</CvLabel><div
                    id={qaId("field-insurance-plan-selector")}
                    data-testid={qaId("field-insurance-plan-selector")}
                    data-qa={qaId("field-insurance-plan-selector")}
                  ><ListOfInsuranceplanName qaIdPrefix={qaId("insurance-plan")} defaultValue={insurancePlans} onChange={handleInsuranceplanChange} clear={clearInsuranceplan} /></div></div>
                <div {...qaAttrs("field-network")} className="cv-field"><CvLabel qaKey="network">Network</CvLabel><div
                    id={qaId("field-network-selector")}
                    data-testid={qaId("field-network-selector")}
                    data-qa={qaId("field-network-selector")}
                  ><ListOfNewNetworkName qaIdPrefix={qaId("network")} defaultValue={network} onChange={handleNetworkChange} clear={clearNetworks} /></div></div>
                <div className="cv-field">
                  <CvLabel qaKey="payer">Payer</CvLabel>
                  <CvInput qaKey="payer" value={payers.join(", ")} onChange={(e) => setPayers(e.target.value.split(","))} placeholder="Enter payer(s)" />
                </div>
                <div {...qaAttrs("field-policy")} className="cv-field"><CvLabel qaKey="policy">Policy</CvLabel><div
                    id={qaId("field-policy-selector")}
                    data-testid={qaId("field-policy-selector")}
                    data-qa={qaId("field-policy-selector")}
                  ><PolicyNames qaIdPrefix={qaId("policy")} onChange={handlePolicyChange} defaultValue={policy} clear={clearPolicy} /></div></div>
                <div {...qaAttrs("field-doctor")} className="cv-field"><CvLabel qaKey="doctor">Doctor</CvLabel><div
                    id={qaId("field-doctor-selector")}
                    data-testid={qaId("field-doctor-selector")}
                    data-qa={qaId("field-doctor-selector")}
                  ><ListOfDoctorName qaIdPrefix={qaId("doctor")} onChange={handleDoctorChange} defaultValue={doctor} clear={clearDoctor} /></div></div>
                <div {...qaAttrs("field-vip")} className="cv-field"><CvLabel qaKey="vip">VIP</CvLabel><div
                    id={qaId("field-vip-selector")}
                    data-testid={qaId("field-vip-selector")}
                    data-qa={qaId("field-vip-selector")}
                  ><Vip qaIdPrefix={qaId("vip")} onChange={handleVipChange} defaultValue={vip} clear={clearVip} /></div></div>
                <div {...qaAttrs("field-specialty")} className="cv-field"><CvLabel qaKey="specialty">Specialty</CvLabel><div
                    id={qaId("field-specialty-selector")}
                    data-testid={qaId("field-specialty-selector")}
                    data-qa={qaId("field-specialty-selector")}
                  ><SpecialtySelector qaIdPrefix={qaId("specialty")} onChange={handleSpecialtyChange} clear={clearSpecialty} value={specialty} /></div></div>
              </div>
            </div>
          )}

          {/* ── Step 3: Diagnosis ── */}
          {currentStep === 3 && (
            <div {...qaAttrs("section-diagnosis-information")} className="cv-section">
              <h2 {...qaAttrs("section-title-diagnosis-information")} className="cv-section-title">Diagnosis Information</h2>
              {diagnosisError && <div {...qaAttrs("diagnosis-error")} className="cv-alert-error">⚠️ {diagnosisError}</div>}
              <table {...qaAttrs("diagnosis-table")} className="cv-table" style={{ marginBottom: 16 }}>
                <thead>
                  <tr>
                    <th>Diagnosis Code</th>
                    <th>Type</th>
    <th style={{ textAlign: "center" }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {primaryDiagnoses && (
                    <tr {...qaAttrs("diagnosis-row-primary")}>
                      <td {...qaAttrs("diagnosis-primary-code")} className="cv-mono">{primaryDiagnoses.value}</td>
                      <td><span className="cv-badge" style={{ background: "#eef2fb", color: "#3b6fd4" }}>Primary</span></td>
                      <td style={{ textAlign: "center" }}>
                        <button {...qaAttrs("btn-delete-primary-diagnosis")} className="cv-btn cv-btn-danger" onClick={() => {
                          if (secondaryDiagnoses.length > 0) { setprimaryDiagnoses({ ...secondaryDiagnoses[0], type: "Primary" }); setsecondaryDiagnoses((p) => p.slice(1)); }
                          else setprimaryDiagnoses(null);
                        }}>Delete</button>
                      </td>
                    </tr>
                  )}
                  {secondaryDiagnoses.map((d, i) => (
                    <tr
                      key={i}
                      id={qaId(`diagnosis-row-secondary-${i}`)}
                      data-testid={qaId(`diagnosis-row-secondary-${i}`)}
                      data-qa={qaId(`diagnosis-row-secondary-${i}`)}
                    >
                      <td
                        id={qaId(`diagnosis-secondary-code-${i}`)}
                        data-testid={qaId(`diagnosis-secondary-code-${i}`)}
                        data-qa={qaId(`diagnosis-secondary-code-${i}`)}
                        className="cv-mono"
                      >
                        {d.value}
                      </td>
                      <td>
                        <div className="cv-select-wrap" style={{ minWidth: 130 }}>
                          <select
                            id={qaId(`select-secondary-diagnosis-type-${i}`)}
                            data-testid={qaId(`select-secondary-diagnosis-type-${i}`)}
                            data-qa={qaId(`select-secondary-diagnosis-type-${i}`)}
                            className="cv-select"
                            style={{ height: 32 }}
                            value={d.type || "Secondary"}
                            onChange={(e) => setsecondaryDiagnoses((p) => p.map((item, idx) => idx === i ? { ...item, type: e.target.value } : item))}>
                            <option value="Secondary">Secondary</option>
                            <option value="Admitting">Admitting</option>
                          </select>
                        </div>
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <button id={qaId(`btn-delete-secondary-diagnosis-${i}`)} data-testid={qaId(`btn-delete-secondary-diagnosis-${i}`)} data-qa={qaId(`btn-delete-secondary-diagnosis-${i}`)} className="cv-btn cv-btn-danger" onClick={() => setsecondaryDiagnoses((p) => p.filter((_, idx) => idx !== i))}>Delete</button>
                      </td>
                    </tr>
                  ))}
                  {!primaryDiagnoses && secondaryDiagnoses.length === 0 && (
                    <tr><td colSpan={3} style={{ textAlign: "center", color: "var(--cv-muted)", padding: 20 }}>No Diagnoses Added Yet</td></tr>
                  )}
                </tbody>
              </table>
        <div
          id={qaId("field-diagnosis-search")}
          data-testid={qaId("field-diagnosis-search")}
          data-legacy-testid="input-claim-icd"
          data-qa={qaId("field-diagnosis-search")}
        >
        <SingleIcdMedicalCodeSearch
  key={`icd-search-${diagnosisSearchKey}`}
  onChange={(selected: DiagnosisOption | null) => {
    if (!selected) return;
    if (!primaryDiagnoses) { 
      setprimaryDiagnoses({ ...selected, type: "Primary" }); 
      setDiagnosisError(""); 
    }
    else if (selected.value !== primaryDiagnoses.value && !secondaryDiagnoses.some((e) => e.value === selected.value)) {
      setsecondaryDiagnoses((p) => [...p, selected]);
    }
    setDiagnosisSearchKey((p) => p + 1);
  }}
  clear={clearsecondaryDiagnoses && clearprimaryDiagnoses}
  description={IcdDescription}
/>
        </div>
            </div>
          )}

          {/* ── Step 4: Activities & Drugs ── */}
          {currentStep === 4 && (
            <div>
              <div {...qaAttrs("section-activity-data")} className="cv-section">
                <h2 {...qaAttrs("section-title-activity-data")} className="cv-section-title">Activity Data</h2>
                {activityError && <div {...qaAttrs("activity-error")} className="cv-alert-error">⚠️ {activityError}</div>}

                <div className="cv-grid">
                  <div className="cv-field">
                    <CvLabel qaKey="activity-id">Activity ID</CvLabel>
                    <CvInput
                      qaKey="activity-id"
                      type="number"
                      value={editingActivityIndex !== null ? editingActivityIndex + 1 : activities.length + 1}
                      disabled
                    />
                  </div>
                  <div className="cv-field">
                    <CvLabel qaKey="activity-type">Activity Type</CvLabel>
                    <div
                      id={qaId("field-activity-type-selector")}
                      data-testid="select-activity-type"
                      data-qa={qaId("field-activity-type-selector")}
                    >
                    <ActivitySelector
                      key={`act-sel-${addCount}`}
                      onSelectActivity={handleActivityTypeChange}
                      selectedActivityType={currentActivity.type}
                    />
                    </div>
                  </div>
                  <div className="cv-field">
                    <CvLabel qaKey="activity-code">Activity Code</CvLabel>
                    <div
                      id={qaId("field-activity-code-selector")}
                      data-testid={qaId("field-activity-code-selector")}
                      data-legacy-testid="input-activity-code"
                      data-qa={qaId("field-activity-code-selector")}
                    >
                    <ListofActivityCode
                      key={`act-code-${addCount}`}
                      onChange={(s: Option[]) => setCurrentActivity({ ...currentActivity, codes: s })}
                      type={currentActivity.type}
                      defaultValue={currentActivity.codes}
                    />
                    </div>
                  </div>
                  <div className="cv-field">
                    <CvLabel qaKey="quantity">Quantity</CvLabel>
                    <CvInput
                      qaKey="quantity"
                      type="number"
                      value={currentActivity.quantity}
                      onChange={(e) => setCurrentActivity({ ...currentActivity, quantity: Number(e.target.value) })}
                      placeholder="1"
                    />
                  </div>
                  <div className="cv-field" style={{ gridColumn: "span 2" }}>
                    <CvLabel qaKey="approval-code">Approval Code (Optional)</CvLabel>
                    <CvInput
                      qaKey="approval-code"
                      value={currentActivity.approvalCode}
                      onChange={(e) => setCurrentActivity({ ...currentActivity, approvalCode: e.target.value })}
                      placeholder="Enter approval code"
                    />
                  </div>

                  {/* ── Tooth Numbers — Dental only, add-one-at-a-time ── */}
                  {currentActivity.type?.toLowerCase() === "dental" && (
                    <div className="cv-field" style={{ gridColumn: "span 2" }}>
                      <CvLabel qaKey="tooth-numbers">Tooth Numbers (Optional)</CvLabel>
                      <div style={{ display: "flex", gap: 8 }}>
                        <CvInput
                          qaKey="tooth-number-draft"
                          value={toothNumberDraft}
                          onChange={(e) => setToothNumberDraft(e.target.value)}
                          placeholder="Enter a tooth number"
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              addToothNumber();
                            }
                          }}
                        />
                        <button
                          {...qaAttrs("btn-add-tooth-number")}
                          type="button"
                          className="cv-btn cv-btn-add"
                          onClick={addToothNumber}
                          style={{ flexShrink: 0 }}
                        >
                          + Add
                        </button>
                      </div>
                      {currentToothNumbers.length > 0 && (
                        <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 8 }}>
                          {currentToothNumbers.map((num) => (
                            <span
                              key={num}
                              id={qaId(`tooth-number-badge-${num}`)}
                              data-testid={qaId(`tooth-number-badge-${num}`)}
                              data-qa={qaId(`tooth-number-badge-${num}`)}
                              className="cv-badge"
                              style={{ background: "#eef2fb", color: "#3b6fd4", display: "inline-flex", alignItems: "center", gap: 6 }}
                            >
                              {num}
                              <span
                                id={qaId(`btn-remove-tooth-number-${num}`)}
                                data-testid={qaId(`btn-remove-tooth-number-${num}`)}
                                data-qa={qaId(`btn-remove-tooth-number-${num}`)}
                                onClick={() => removeToothNumber(num)}
                                style={{ cursor: "pointer", fontWeight: 700 }}
                              >
                                ×
                              </span>
                            </span>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </div>

                <div className="cv-divider" />

                <div className="cv-actions-row">
                  <button
                    id={qaId(editingActivityIndex !== null ? "btn-update-activity" : "btn-add-activity")}
                    data-testid={editingActivityIndex !== null ? "btn-update-activity" : "btn-add-activity"}
                    data-qa={qaId(editingActivityIndex !== null ? "btn-update-activity" : "btn-add-activity")}
                    data-qa-action={editingActivityIndex !== null ? "update-activity" : "add-activity"}
                    className="cv-btn cv-btn-add"
                    onClick={addActivityToTable}
                  >
                    {editingActivityIndex !== null ? "✓ Update Activity" : "+ Add Activity"}
                  </button>
                  {editingActivityIndex !== null && (
                    <button {...qaAttrs("btn-cancel-edit-activity")} className="cv-btn cv-btn-outline" onClick={cancelEditActivity}>Cancel</button>
                  )}
                </div>

                {activities.length > 0 && (
                  <div className="cv-mt-md">
                    <div
                      {...qaAttrs("selected-activities-title")}
                      style={{ fontWeight: 700, fontSize: 13, marginBottom: 10, color: "var(--cv-text)", display: "flex", alignItems: "center", gap: 8 }}
                    >
                      Selected Activities
                      <span
                        {...qaAttrs("selected-activities-count")}
                        data-count={activities.length}
                        style={{ background: "var(--cv-accent)", color: "#fff", fontSize: 10, fontWeight: 700, padding: "2px 8px", borderRadius: 20 }}
                      >
                        {activities.length}
                      </span>
                    </div>
                    <div style={{ overflowX: "auto" }}>
                      <table {...qaAttrs("activities-table")} className="cv-table">
                        <thead>
                          <tr>
                            <th>ID</th>
                            <th>Type</th>
                            <th>Codes</th>
                            <th>Qty</th>
                            <th>Approval Code</th>
                            <th>Tooth Number</th>
                            <th style={{ textAlign: "center" }}>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {activities.map((activity, index) => (
                            <tr key={`act-row-${index}`} id={qaId(`activity-row-${index}`)} data-testid={qaId(`activity-row-${index}`)} data-qa={qaId(`activity-row-${index}`)} data-activity-type={activity.type}>
                              <td className="cv-mono">{index + 1}</td>
                              <td>{activity.type}</td>
                              <td className="cv-mono">{activity.codes.map((c) => c.value).join(", ")}</td>
                              <td>{activity.quantity}</td>
                              <td className="cv-mono">{activity.approvalCode || <span style={{ color: "var(--cv-muted)" }}>—</span>}</td>
                              <td className="cv-mono">
                                {activity.toothNumbers.length > 0
                                  ? activity.toothNumbers.join(", ")
                                  : <span style={{ color: "var(--cv-muted)" }}>—</span>}
                              </td>
                              <td style={{ textAlign: "center", display: "flex", gap: 6, justifyContent: "center" }}>
                                <button id={qaId(`btn-edit-activity-${index}`)} data-testid={qaId(`btn-edit-activity-${index}`)} data-qa={qaId(`btn-edit-activity-${index}`)} className="cv-btn cv-btn-outline" style={{ height: 30, padding: "0 12px", fontSize: 12 }} onClick={() => startEditActivity(index)}>Edit</button>
                                <button id={qaId(`btn-delete-activity-${index}`)} data-testid={qaId(`btn-delete-activity-${index}`)} data-qa={qaId(`btn-delete-activity-${index}`)} className="cv-btn cv-btn-danger" onClick={() => removeActivity(index)}>Delete</button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>

              {/* Drugs */}
              <div {...qaAttrs("section-drugs-information")} className="cv-section">
                <h2 {...qaAttrs("section-title-drugs-information")} className="cv-section-title">Drugs Information</h2>
                <div className="cv-grid" style={{ gridTemplateColumns: "1fr 1fr", marginBottom: 12 }}>
                  <div className="cv-field">
                    <CvLabel qaKey="drug-code">Drug Code</CvLabel>
                    <div
                    id={qaId("field-drug-code-selector")}
                    data-testid={qaId("field-drug-code-selector")}
                    data-qa={qaId("field-drug-code-selector")}
                  >
                    <ListOfDrugCode onChange={(s: Option[] | null) => setDrugCode(s || [])} value={DrugCode} clear={clearDrugCode} />
                    </div>
                  </div>
                  <div className="cv-field">
                    <CvLabel qaKey="drug-total">Total</CvLabel>
                    <CvInput qaKey="drug-total" type="number" placeholder="Enter total" value={total !== undefined ? total : ""} onChange={(e) => setTotal(Number(e.target.value))} />
                  </div>
                </div>
                <button
                  {...qaAttrs("btn-add-drug")}
                  className="cv-btn cv-btn-add"
                  onClick={handleAddDrug}
                  disabled={DrugCode.length === 0 || total === undefined}
                  style={{
                    opacity: (DrugCode.length === 0 || total === undefined) ? 0.45 : 1,
                    cursor: (DrugCode.length === 0 || total === undefined) ? "not-allowed" : "pointer",
                  }}
                >
                  + Add Drug
                </button>
                {drugsTableRows.length > 0 && (
                  <div className="cv-mt-md" style={{ overflowX: "auto" }}>
                    <table {...qaAttrs("drugs-table")} className="cv-table">
<thead><tr><th>Drug Code</th><th>Total</th><th style={{ textAlign: "center" }}>Action</th></tr></thead>
                      <tbody>
                        {drugsTableRows.map((row, index) => (
                          <tr key={index} id={qaId(`drug-row-${index}`)} data-testid={qaId(`drug-row-${index}`)} data-qa={qaId(`drug-row-${index}`)}>
                            <td className="cv-mono">{row.drugCode}</td>
                            <td>{row.total}</td>
                            <td style={{ textAlign: "center" }}>
                              <button id={qaId(`btn-delete-drug-${index}`)} data-testid={qaId(`btn-delete-drug-${index}`)} data-qa={qaId(`btn-delete-drug-${index}`)} className="cv-btn cv-btn-danger" onClick={() => handleDeleteRow(index)}>Delete</button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* ── Step 5: Encounter ── */}
          {currentStep === 5 && (
            <div {...qaAttrs("section-encounter-information")} className="cv-section">
              <h2 {...qaAttrs("section-title-encounter-information")} className="cv-section-title">Encounter Information</h2>
              <div className="cv-grid">
                <div className="cv-field">
                  <CvLabel qaKey="encounter-type">Encounter Type</CvLabel>
                  <CvSelect qaKey="encounter-type" value={encounter.Type} onChange={(e) => setEncounter({ ...encounter, Type: e.target.value })}>
                    <option value="1">1 (OPD)</option>
                    <option value="3">3 (IPD)</option>
                  </CvSelect>
                </div>
                <div className="cv-field">
                  <CvLabel qaKey="encounter-end">Encounter End</CvLabel>
                  <CvInput qaKey="encounter-end" type="date" value={encounter.End.split(" ")[0] || ""} onChange={(e) => setEncounter({ ...encounter, End: e.target.value ? `${e.target.value.replace(/-/g, "/")} 00:00` : "" })} />
                </div>
                <div className="cv-field">
                  <CvLabel qaKey="encounter-start-type">Encounter Start Type</CvLabel>
                  <CvInput qaKey="encounter-start-type" value={encounter.StartType} onChange={(e) => setEncounter({ ...encounter, StartType: e.target.value })} placeholder="Enter start type" />
                </div>
                <div className="cv-field">
                  <CvLabel qaKey="encounter-end-type">Encounter End Type</CvLabel>
                  <CvInput qaKey="encounter-end-type" value={encounter.EndType} onChange={(e) => setEncounter({ ...encounter, EndType: e.target.value })} placeholder="Enter end type" />
                </div>
                <div className="cv-field">
                  <CvLabel qaKey="transfer-source">Transfer Source</CvLabel>
                  <CvInput qaKey="transfer-source" value={encounter.TransferSource} onChange={(e) => setEncounter({ ...encounter, TransferSource: e.target.value })} placeholder="Enter transfer source" />
                </div>
                <div className="cv-field">
                  <CvLabel qaKey="transfer-destination">Transfer Destination</CvLabel>
                  <CvInput qaKey="transfer-destination" value={encounter.TransferDestination} onChange={(e) => setEncounter({ ...encounter, TransferDestination: e.target.value })} placeholder="Enter transfer destination" />
                </div>
                <div className="cv-field">
                  <CvLabel qaKey="gross">Gross</CvLabel>
                  <CvInput qaKey="gross" value={gross} onChange={(e) => setGross(e.target.value)} placeholder="Enter gross amount" />
                </div>
                <div className="cv-field">
                  <CvLabel qaKey="patient-share">Patient Share</CvLabel>
                  <CvInput qaKey="patient-share" value={patientShare} onChange={(e) => setPatientShare(e.target.value)} placeholder="Enter patient share" />
                </div>
                <div className="cv-field">
                  <CvLabel qaKey="net">Net</CvLabel>
                  <CvInput qaKey="net" value={net} onChange={(e) => setNet(e.target.value)} placeholder="Enter net amount" />
                </div>
                <div className="cv-field">
                  <CvLabel qaKey="type">Type</CvLabel>
                  <CvInput qaKey="type" value={type} onChange={(e) => setType(e.target.value)} placeholder="Enter type" />
                </div>
              </div>
            </div>
          )}
        </div>

        {/* ── Step 6: Results ── */}
        {currentStep === 6 && (
          <div
            id={qaId("section-results")}
            data-testid="claim-result-message"
            data-qa={qaId("section-results")}
          >
            {isLoading ? (
              <div {...qaAttrs("results-loading")} style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: 300, gap: 16 }}>
                <div style={{ width: 44, height: 44, border: "4px solid var(--cv-border)", borderTopColor: "var(--cv-accent)", borderRadius: "50%", animation: "cv-spin 0.8s linear infinite" }} />
                <span {...qaAttrs("results-loading-text")} style={{ color: "var(--cv-muted)", fontSize: 14 }}>Running Validations...</span>
              </div>
            ) : validationResults.length === 0 ? (
              <div {...qaAttrs("results-empty")} style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: 300, gap: 12, color: "var(--cv-muted)" }}>
                <span style={{ fontSize: 48 }}>📋</span>
                <span style={{ fontSize: 14 }}>No Validation Results Yet.</span>
              </div>
            ) : (
              <div>
                {validationResults.map((rg: any, gi: number) => (
                  <div key={gi} id={qaId(`validation-claim-group-${gi}`)} data-testid={qaId(`validation-claim-group-${gi}`)} data-qa={qaId(`validation-claim-group-${gi}`)} data-claim-id={rg.claim_ID || ""} style={{ marginBottom: 20 }}>
                    <div className="cv-claim-group-title">
                      {rg.claim_ID && <><span>Claim</span><span className="id">{rg.claim_ID}</span></>}
                      {rg.date && <span style={{ marginLeft: "auto", fontSize: 11 }}>{new Date(rg.date).toLocaleString()}</span>}
                    </div>
                    {(rg.validations || [rg]).map((validation: any, idx: number) =>
                      renderValidationCard(validation, idx, rg.claim_ID)
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* Nav */}
        <div {...qaAttrs("navigation")} className="cv-nav">
          <button
            {...qaAttrs("btn-reset")}
            className="cv-btn"
            style={{ background: "#fef2f2", color: "#dc2626", border: "1.5px solid #fca5a5", fontWeight: 600 }}
            onClick={handleReset}
          >
            ↺ Reset
          </button>
          <div style={{ display: "flex", gap: 10 }}>
            <button
              id={qaId(`btn-previous-step-${currentStep}`)}
              data-testid="btn-claim-previous"
              data-qa={qaId(`btn-previous-step-${currentStep}`)}
              data-qa-action="previous"
              data-current-step={currentStep}
              className="cv-btn cv-btn-outline"
              onClick={handlePrevious}
              disabled={currentStep === 1}
            >
              ← Previous
            </button>
            {currentStep < 5
              ? (
                <button
                  id={qaId(`btn-next-step-${currentStep}`)}
                  data-testid="btn-claim-next"
                  data-qa={qaId(`btn-next-step-${currentStep}`)}
                  data-qa-action="next"
                  data-current-step={currentStep}
                  className="cv-btn cv-btn-primary"
                  onClick={() => void handleNext()}
                >
                  Next →
                </button>
              )
              : currentStep === 5
              ? (
                <button
                  id={qaId("btn-validate-step-5")}
                  data-testid="btn-claim-validate"
                  data-qa={qaId("btn-validate-step-5")}
                  data-qa-action="validate"
                  data-current-step={currentStep}
                  className="cv-btn cv-btn-primary"
                  onClick={handleValidateAndNext}
                  disabled={isLoading}
                >
                  {isLoading ? <><span className="cv-spinner" /> Validating…</> : "✓ Validate"}
                </button>
              )
              : null
            }
          </div>
        </div>

        {responseMessage && (
          <div id={qaId("response-message")} data-testid="claim-response-message" data-qa={qaId("response-message")} className={responseMessage.includes("failed") ? "cv-alert-fail" : "cv-alert-success"}>
            {responseMessage}
          </div>
        )}
      </div>
      <div {...qaAttrs("toaster-wrapper")}>
        <Toaster />
      </div>
    </div>
  );
};

export default ClaimValidation;